import { CurrentUser, QButton, useCurrentUser } from '@qualio/ui-components';
import { QualioDocument } from '../../../../../../../api/model/document';
import { WorkspaceTabs } from '../../../WorkspaceV2';

export type BulkActionButtonProps = {
  label?: string;
  requiredPermissions: readonly string[];
  isActionAllowed: (
    user: CurrentUser,
    statuses: QualioDocument['status_id'][],
    currentTab: WorkspaceTabs,
    requiredPermissions: readonly string[],
    selectedDocuments: QualioDocument[],
  ) => boolean;
  currentTab: WorkspaceTabs;
  onClick: () => void;
  isLoading?: boolean;
  statuses: QualioDocument['status_id'][];
  selectedDocuments: QualioDocument[];
};

export const BulkActionButton = ({
  isActionAllowed,
  label,
  currentTab,
  requiredPermissions,
  onClick,
  isLoading,
  statuses,
  selectedDocuments,
}: BulkActionButtonProps) => {
  const currentUser = useCurrentUser();

  if (
    !isActionAllowed(
      currentUser,
      statuses || [],
      currentTab,
      requiredPermissions,
      selectedDocuments,
    )
  ) {
    return null;
  }
  return (
    <QButton variant="outline" onClick={onClick} isLoading={isLoading}>
      {label}
    </QButton>
  );
};
